// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"774":"31f55ccb","787":"4ebb082f","891":"c584f2a1"}[chunkId] + ".chunk.js";
};